import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { UnsavedAlertComponent } from 'src/app/shared/components/unsaved-alert/unsaved-alert.component';
import { HttpService } from 'src/app/shared/services/http.service';
import { TableService } from 'src/app/shared/services/tableService/table.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-carrier',
  standalone: false,
  templateUrl: './edit-carrier.component.html',
  styleUrl: './edit-carrier.component.scss'
})
export class EditCarrierComponent implements OnInit, AfterViewInit {

  public carrierForm: FormGroup;
  public dataSource: any;
  public operation = "add";
  public countryListArr: any;
  userData:any;
  public categoryList:any;
  isValuesChanged:boolean = false;

  constructor(public appService: AppService, private httpService: HttpService, 
    private tableService:TableService, private router:Router, private dialog:MatDialog) {
    this.carrierForm = new FormGroup({
      gsdb: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required),
      street: new FormControl(''),
      postcode: new FormControl(''),
      city: new FormControl(''),

      country: new FormControl('', Validators.required),
      imcs: new FormControl('', Validators.required),
      vatCode: new FormControl(''),
      createdDate: new FormControl(''),
      modifiedDate: new FormControl(''),
      createdBy: new FormControl(''),
      modifiedBy: new FormControl('')
    });
    this.getContactType();
  }

  ngOnInit(): void {
    let userData = sessionStorage.getItem("user-data");
    this.userData = userData?JSON.parse(userData):null;
    this.dataSource = (history.state).data;
    this.operation = (history.state).operation;
    this.carrierForm.controls['gsdb'].valueChanges.subscribe(value => {
      this.carrierForm.controls['gsdb'].patchValue(value.toUpperCase(), { emitEvent: false });
    });
    this.carrierForm.controls['imcs'].valueChanges.subscribe(value => {
      this.carrierForm.controls['imcs'].patchValue(value.toUpperCase(), { emitEvent: false });
    });
    if(this.operation === "edit" && this.dataSource.Status === 'Terminated'){
      this.operation = this.dataSource.Iscopy? 'edit':'view'
    }
  }

  ngAfterViewInit(): void {
    this.toUpdateOnField();
    this.getCountryList();
    this.isValuesChanged = false;
    Object.keys(this.carrierForm.controls).forEach(controlName => {
      this.carrierForm.get(controlName)!.valueChanges.subscribe((value:any) => {
        this.isValuesChanged = true;
      });
    });
  }

  toUpdateOnField() {
    this.carrierForm.enable();
    if (this.operation === 'add') {
      this.carrierForm.patchValue({
        createdBy: (this.userData.Email).includes('dhl')?'LLP User':this.userData.Email,
        createdDate: this.appService.getWithFormatToday(),
        modifiedDate: '',//this.appService.getWithFormatToday(),
        modifiedBy: '',//(this.userData.Email).includes('dhl')?'LLP User':this.userData.Email,
        country: ''
      })
      return;
    }
    if (this.operation === 'view') {
      this.carrierForm.disable();
    }

    this.carrierForm.patchValue({
      gsdb: this.dataSource.ContractGSDB,
      name: this.dataSource.Name,
      street: this.dataSource.Street,
      postcode: this.dataSource.Postcode,
      city: this.dataSource.City,
      country: this.dataSource.CountryID,
      imcs: this.dataSource.IMCSSiteCode,
      vatCode: this.dataSource.VATCode,
      createdDate: this.tableService.checkOnInvalidDate(this.dataSource.CreatedOn),
      modifiedDate: this.tableService.checkOnInvalidDate(this.dataSource.ModifiedOn),
      createdBy: this.dataSource.CreatedBy,
      modifiedBy: this.dataSource.ModifiedBy
    })

  }

  getContactType(){
    this.appService.isLoading = true;
    this.httpService.getListOfData('Carrier')
      .subscribe((res: any) => {
        this.appService.isLoading = false;
        if (res) {
          this.categoryList = res;
        }
    })
  }

  onKeyDown(event: KeyboardEvent, condition=false) {
    if(condition)
      return;
    event.preventDefault();
  }

  onDelete() {
    if (this.operation === 'view') {
      return;
    }
    this.tableService.deleteItem('Carrier', 'CarrierID',this.dataSource.CarrierID,this);
  }
  onCopy() {
    if (this.operation === 'view') {
      return;
    }
    this.operation = 'add';
    // this.carrierForm.get('gsdb')?.setValue('')
    this.carrierForm.patchValue({
      modifiedDate: '',//this.appService.getWithFormatToday(),
      modifiedBy: '',//(this.userData.Email).includes('dhl')?'LLP User':this.userData.Email,
      gsdb: ''
    })
  }
  
  onSave() {
    if (this.operation === 'view') {
      return;
    }
    if (this.carrierForm.invalid) {
      this.httpService.openSnackBar('Please fill all the required Field')
      return;
    }
    
    let find:any = null 
    find= this.tableService.carrierDBSOurce?.find((item:any)=>(item.ContractGSDB).toLowerCase() === (this.carrierForm.get('gsdb')?.value).toLowerCase());
    if(find && this.operation === "add"){
      this.httpService.openSnackBar('GSDB Already Exist');
      return;
    }
if(this.tableService.carrierDBSOurce && this.tableService.carrierDBSOurce.lnegth>0){
    let exisitingIMCSSiteCode = this.tableService.carrierDBSOurce?.map((i:any) => i.IMCSSiteCode);
    let totalIMCSCode = exisitingIMCSSiteCode?.map((item:any) => item.split(';').map((str:string) => str.trim())) // Split and trim
    .reduce((acc:any, curr:any) => acc.concat(curr), []); 
    console.log("totalIMCSCode",totalIMCSCode,exisitingIMCSSiteCode);
    
    let imcsCodeItems = ([this.carrierForm.get('imcs')?.value]).map((item:any) => item.split(';').map((str:string) => str.trim())) // Split and trim
    .reduce((acc:any, curr:any) => acc.concat(curr), []); 
    if(this.operation === 'edit'){
      let currentIMSC = (this.dataSource.IMCSSiteCode).split(";");
      currentIMSC.forEach((i:any) => {
        totalIMCSCode = totalIMCSCode.filter((item:any) => !i.includes(item.trim()));
      });
    }
    const hasCommonItems = totalIMCSCode.some((item:any) => imcsCodeItems.includes(item));
    if(hasCommonItems && this.tableService.carrierDBSOurce.length>0){
      this.httpService.openSnackBar('GSDB Site Code is already Exist');
      return;
    }
  }
    let statusList = this.categoryList.filter((item:any)=>item.Category === 'CarrierStatus');
    let id = statusList.find((item:any)=>item.LookUpName === 'Not Active')?.LookUpID;

    let body = {
      'CarrierID': this.operation === 'add' ? null : (this.dataSource.Status === 'Terminated' && this.dataSource.Iscopy?null: this.dataSource.CarrierID),
      'Name': this.carrierForm.get('name')?.value,
      'UserEmail': this.operation === 'add' ? this.userData.Email : this.carrierForm.get('createdBy')?.value,
      'CarrierStatusID': this.operation === 'add' ? id : this.dataSource.CarrierStatusID,
      'CountryID': this.carrierForm.get('country')?.value,
      'Street': this.carrierForm.get('street')?.value,
      'Postcode': this.carrierForm.get('postcode')?.value,
      "ContractGSDB": this.carrierForm.get('gsdb')?.value,
      "City": this.carrierForm.get('city')?.value,
      "IMCSSiteCode": this.carrierForm.get('imcs')?.value,
      'VATCode': this.carrierForm.get('vatCode')?.value,
    }
    this.httpService.setCarrierDetails(body)
      .subscribe((res: any) => {
        this.appService.isLoading = false;
        if (res) {
          // if(this.operation === "add"){
          //   this.operation = "edit";
          //   this.dataSource ={Name:'',Status:''}
          //   this.dataSource.Name = this.carrierForm.get('name')?.value;
          //   this.dataSource.Status = "Active";            
          // }
          this.httpService.openSnackBar(res[0].MSG);
          if(res[0].DuplicateFlag === 0){
            this.router.navigateByUrl('/home/carrier')
          }
        }
      })
  }

  onbackCall(){
    if(this.isValuesChanged){
      const dialogRef = this.dialog.open(UnsavedAlertComponent, {
              disableClose: false,
            });
            dialogRef.afterClosed().subscribe((evt:any) => {
              if(evt.operation === "confirm"){
                this.router.navigateByUrl('/home/carrier')
              }
            })
    }
    else{
      this.router.navigateByUrl('/home/carrier')
    }
  }

  getCountryList() {
    this.httpService.getCountryList()
      .subscribe((res: any) => {
        this.appService.isLoading = false;
        if (res) {
          this.countryListArr = res.filter((item: any) => item.ISMaut);
          this.countryListArr.sort((a:any, b:any) => ((a.CountryName).toLowerCase() > (b.CountryName).toLowerCase()) ? 1 : -1);  
        }
      })
  }

}
